<div class="gsm-date-range-picker">
  <div class="gsm-date-range-picker__inputs">
    <label>Von</label>
    <mat-form-field class="gsm-date-range-picker__from">
      <input
        matInput
        [required]="model.required"
        [disabled]="model.disabled"
        [(ngModel)]="startInputValue"
        (focus)="handleFocus(this.startDate)"
        (blur)="handleTextInputBlurStart()"
        data-test="drp-input-from"
      />
    </mat-form-field>

    <label>bis</label>
    <mat-form-field class="gsm-date-range-picker__to">
      <input
        matInput
        [required]="model.required"
        [disabled]="model.disabled"
        [(ngModel)]="endInputValue"
        (focus)="handleFocus(this.endDate)"
        (blur)="handleTextInputBlurEnd()"
        data-test="drp-input-to"
      />
    </mat-form-field>
  </div>
  <div class="gsm-date-range-picker__picker-container" *ngIf="!model.disabled">
    <mat-card>
      <mat-calendar
        #calendar
        class="gsm-date-range-picker__picker"
        [dateClass]="dateClass"
        [(selected)]="pickerValue"
        [maxDate]="maxDate"
        [minDate]="minDate"
        [startAt]="startDate"
      ></mat-calendar>
    </mat-card>
  </div>
</div>
